import type { ReactNode, SVGProps } from 'react';

export type IconProps = Omit<SVGProps<SVGSVGElement>, 'children'> & {
  /** Rendered width/height in px (viewBox is always 24x24). */
  size?: number;
};

type BaseProps = IconProps & { children: ReactNode };

/** Shared frame for the original line icons: 24x24 viewBox, stroke 2, round caps. */
export function Icon({ size = 20, children, ...rest }: BaseProps) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      {children}
    </svg>
  );
}
